module.exports = __webpack_public_path__ + "img/plan.9f1afbc6.svg";